import React from 'react'
import { Route, Switch, Redirect, useRouteMatch } from "react-router-dom";
import { MilestoneRoutes } from './Constants/routes';

const MilestonesModule = () => {
  const match = useRouteMatch();

  return (
    <>
      <Switch>
        <Redirect exact from={`${match.url}/`} to={`${match.url}/all`} />
        {MilestoneRoutes.map(({ path, Component, exact, id }) => (
          <Route
            path={`${match.url}${path}`}
            exact={exact}
            component={Component}
            key={id}
          />
        ))}
        <Redirect to="/dashboard/milestones" />
      </Switch>
    </>
  )
}

export default MilestonesModule;
